module.exports = __webpack_public_path__ + "static/media/CodeQuest2.0_Sliding_Image.daffcdac.png";